import React, { useState } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { TableCell, TableRow, FormLabel, Chip, TableBody, FormControl, Table, Grid } from '@material-ui/core';
import { RxOrder, RxOrderStatusEnum, Status } from 'openapi';
import StatusColumn from '../labels/StatusColumn';
import EditDeleteButtons from '../buttons/EditDeleteButtons';
import RxOrderContainer from '../../containers/RxOrder';
import UploadButton from '../buttons/UploadButton';
import MakerText from '../labels/MakerText';
import LensText from '../labels/LensText';
import ConfirmCancelButtons from '../buttons/ConfirmCancelButtons';
import ColorText from '../labels/ColorText';
import ColorTypeText from '../labels/ColorTypeText';
import DensityText from '../labels/DensityText';
import { Formik, Form, FormikHelpers } from 'formik';
import OptionText from '../labels/OptionText';
import KarteMemo from '../labels/KarteMemo';
import StatusPanel from '../panels/StatusPanel';
import dateFormat from 'dateformat';

interface Props {
    rowData: RxOrder,
    onOrder: (rxOrder: RxOrder) => void,
    isLoading: boolean
}

interface FormValues {
    meganetLensRxOrderId: number,
    customerName: string,
    status: RxOrderStatusEnum,
    recordedDate: Date,
    leftMeganetLensMasterId: number,
    leftPd: number,
    leftSph: number,
    leftCyl: number,
    leftAx: number,
    leftAdd: number,
    leftOutDia: number,
    rightMeganetLensMasterId: number,
    rightPd: number,
    rightSph: number,
    rightCyl: number,
    rightAx: number,
    rightAdd: number,
    rightOutDia: number,
    meganetColorDensityMappingId: number,
    remarks: string,
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    table: {
        minWidth: 650,
    },
    rowBlur: {
        opacity: 0.2,
        transition: 'all ease 300ms'
    },
    rowShow: {
        opacity: 1,
        transition: 'all ease 300ms'
    },
    formControl: {
        margin: theme.spacing(1),
        display: 'block'
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
}));

export default ((props) => {
    const rxOrderContainer = RxOrderContainer.useContainer();
    const [open, setOpen] = useState(false);
    const [statusList, setStatusList] = useState<Status[]>([]);
    const classes = useStyles({});

    const handleEdit = (meganetLensRxOrderId: number) => {

        rxOrderContainer.setIsEditing(true);
        rxOrderContainer.setSelectedOrderId(meganetLensRxOrderId ? meganetLensRxOrderId : -1);
    };

    const handleDelete = (meganetLensRxOrderId: number) => {
        rxOrderContainer.setIsDeleting(true);
        rxOrderContainer.setSelectedOrderId(meganetLensRxOrderId ? meganetLensRxOrderId : -1);
    };

    const handleSumbit = async (values: FormValues, formikHelpers: FormikHelpers<FormValues>) => {
        (async () => {
            if (rxOrderContainer.isDeleting) {
                values.meganetLensRxOrderId = rxOrderContainer.selectedOrderId;
                // Delete row
                await rxOrderContainer.remove(values.meganetLensRxOrderId);
                rxOrderContainer.setIsDeleting(false);
            }
        })()

        formikHelpers.setSubmitting(false);
    }

    const handleCancel = (meganetLensRxOrderId: number | undefined) => {
        if (rxOrderContainer.isEditing) {
            rxOrderContainer.setIsEditing(false);
        }

        if (rxOrderContainer.isDeleting) {
            rxOrderContainer.setIsDeleting(false);
        }

        if (rxOrderContainer.isNewRow) {
            rxOrderContainer.setIsNewRow(false);
        }

        // Reset selectedOrderId
        rxOrderContainer.setSelectedOrderId(-1);
    }

    const handleUpload = async (selectedRxOrder: RxOrder) => {
        props.onOrder(selectedRxOrder);
    }

    const handleStatus = async (orderId: number) => {
        // Show panel
        setOpen(true);

        // get status List
        var results = await rxOrderContainer.getStatusList(orderId);
        setStatusList(results ? results : []);
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <StatusPanel handleClickOpen={() => handleStatus} handleClose={handleClose} open={open} statusList={statusList} />
            <TableRow className={rxOrderContainer.isEditing || rxOrderContainer.isNewRow || (rxOrderContainer.isDeleting && rxOrderContainer.selectedOrderId !== props.rowData.meganetLensRxOrderId) ? classes.rowBlur : classes.rowShow}>
                <TableCell>
                    <Formik
                        initialValues={props.rowData as FormValues}
                        onSubmit={handleSumbit}
                    >
                        {({ isSubmitting }) => (
                            <Form className={classes.form} noValidate>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell ><StatusColumn status={props.rowData.status} orderId={props.rowData.meganetLensRxOrderId} handleStatus={handleStatus} /></TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='karteNoLabel' style={{ fontSize: 13, }}>{props.rowData.karteNo ? 'Karte No' : ''}</FormLabel>
                                                    <br />
                                                    <FormLabel id='karteNo' style={{ color: 'black' }}>{props.rowData.karteNo !== undefined ? props.rowData.karteNo : ''}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='customerNameLabel' style={{ fontSize: 13, }}>{props.rowData.customerName ? 'Customer Name' : ''}</FormLabel>
                                                    <br />
                                                    <FormLabel id='customerName' style={{ color: 'black' }}>{props.rowData.customerName}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='shippingDateLabel' style={{ fontSize: 13, }}>{props.rowData.shippingDate ? 'Shipping Date' : ''}</FormLabel>
                                                    <br />
                                                    <FormLabel id='shippingDate' style={{ color: 'black' }}>{props.rowData.shippingDate !== undefined ? dateFormat(props.rowData.shippingDate, 'yyyy/mm/dd') : ''}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='left'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='maker' style={{ fontSize: 13, }}>Maker</FormLabel>
                                                    <br />
                                                    <MakerText meganetLensMasterId={props.rowData.leftMeganetLensMasterId} />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='left'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='color' style={{ fontSize: 13, }}>Color</FormLabel>
                                                    <br />
                                                    <ColorText meganetColorDensityMappingId={props.rowData.meganetColorDensityMappingId} />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='left'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='color' style={{ fontSize: 13, }}>Color Type</FormLabel>
                                                    <br />
                                                    <ColorTypeText meganetColorDensityMappingId={props.rowData.meganetColorDensityMappingId} />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='left'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='denTop' style={{ fontSize: 13, }}>Density</FormLabel>
                                                    <br />
                                                    <DensityText meganetColorDensityMappingId={props.rowData.meganetColorDensityMappingId} />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FormControl className={classes.formControl}>
                                                    <Chip size="small" style={{ color: 'black', backgroundColor: 'lightgray' }} label='Right' />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='maker' style={{ fontSize: 13, }}>Lens</FormLabel>
                                                    <br />
                                                    <LensText meganetLensMasterId={props.rowData.rightMeganetLensMasterId} />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='rightSph' style={{ fontSize: 13, }}>Right Sph</FormLabel>
                                                    <br />
                                                    <FormLabel id='rightSph' style={{ color: 'black' }}>{props.rowData.rightSph.toFixed(2)}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='rightCyl' style={{ fontSize: 13, }}>Right Cyl</FormLabel>
                                                    <br />
                                                    <FormLabel id='rightCyl' style={{ color: 'black' }}>{props.rowData.rightCyl.toFixed(2)}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='rightAx' style={{ fontSize: 13, }}>Right Ax</FormLabel>
                                                    <br />
                                                    <FormLabel id='rightAx' style={{ color: 'black' }}>{props.rowData.rightAx}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='rightAdd' style={{ fontSize: 13, }}>Right Add</FormLabel>
                                                    <br />
                                                    <FormLabel id='rightAdd' style={{ color: 'black' }}>{props.rowData.rightAdd.toFixed(2)}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='rightOutDia' style={{ fontSize: 13, }}>Right OutDia</FormLabel>
                                                    <br />
                                                    <FormLabel id='rightOutDia' style={{ color: 'black' }}>{props.rowData.rightOutDia}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='remarks' style={{ fontSize: 13, }}>{props.rowData.remarks ? 'Remarks' : ''}</FormLabel>
                                                    <br />
                                                    <FormLabel id='remarks' style={{ color: 'black' }}>{props.rowData.remarks}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        {(props.rowData.rightMemo) ?
                                            <TableRow>
                                                <TableCell>
                                                    <FormControl className={classes.formControl}>
                                                        <Chip size="small" style={{ color: 'black', backgroundColor: 'lightgray' }} label='Right Memo' />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell colSpan={6}>
                                                    <FormControl className={classes.formControl}>
                                                        <KarteMemo memo={props.rowData.rightMemo} />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            :
                                            <></>
                                        }
                                        {(props.rowData.rightOptionItemIds && props.rowData.rightOptionItemIds.length > 0) && <OptionText isLoading={props.isLoading} optionItemIds={props.rowData.rightOptionItemIds} leftRight={0} pd={props.rowData.rightPd} label='Right Option' />}
                                        <TableRow>
                                            <TableCell>
                                                <FormControl className={classes.formControl}>
                                                    <Chip size="small" style={{ color: 'black', backgroundColor: 'lightgray' }} label='Left' />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='maker' style={{ fontSize: 13, }}>Lens</FormLabel>
                                                    <br />
                                                    <LensText meganetLensMasterId={props.rowData.leftMeganetLensMasterId} />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='leftSph' style={{ fontSize: 13, }}>Left Sph</FormLabel>
                                                    <br />
                                                    <FormLabel id='leftSph' style={{ color: 'black' }}>{props.rowData.leftSph.toFixed(2)}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='leftCyl' style={{ fontSize: 13, }}>Left Cyl</FormLabel>
                                                    <br />
                                                    <FormLabel id='leftCyl' style={{ color: 'black' }}>{props.rowData.leftCyl.toFixed(2)}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='leftAx' style={{ fontSize: 13, }}>Left Ax</FormLabel>
                                                    <br />
                                                    <FormLabel id='leftAx' style={{ color: 'black' }}>{props.rowData.leftAx}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='leftAdd' style={{ fontSize: 13, }}>Left Add</FormLabel>
                                                    <br />
                                                    <FormLabel id='leftAdd' style={{ color: 'black' }}>{props.rowData.leftAdd.toFixed(2)}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='right'>
                                                <FormControl className={classes.formControl}>
                                                    <FormLabel id='leftOutDia' style={{ fontSize: 13, }}>Left OutDia</FormLabel>
                                                    <br />
                                                    <FormLabel id='leftOutDia' style={{ color: 'black' }}>{props.rowData.leftOutDia}</FormLabel>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell align='left'>
                                                {(props.rowData.status === RxOrderStatusEnum.Waiting || props.rowData.status === RxOrderStatusEnum.Error) ?
                                                    (rxOrderContainer.isEditing || rxOrderContainer.isDeleting) && rxOrderContainer.selectedOrderId === props.rowData.meganetLensRxOrderId ?
                                                        <FormControl className={classes.formControl}>
                                                            <ConfirmCancelButtons meganetLensRxOrderId={props.rowData.meganetLensRxOrderId} isSubmitting={isSubmitting} onCancel={handleCancel} />
                                                        </FormControl>
                                                        :
                                                        <FormControl className={classes.formControl}>
                                                            <Grid container
                                                                direction='row'
                                                                justify='center'
                                                                alignItems='flex-end'>
                                                                <Grid item>
                                                                    <EditDeleteButtons meganetLensRxOrderId={props.rowData.meganetLensRxOrderId} onEdit={handleEdit} onDelete={handleDelete} />
                                                                </Grid>
                                                                <Grid item>
                                                                    <UploadButton rowData={props.rowData} onUpload={handleUpload} isLoading={props.isLoading} />
                                                                </Grid>
                                                            </Grid>
                                                        </FormControl>
                                                    :
                                                    <>
                                                    </>
                                                }
                                            </TableCell>
                                        </TableRow>
                                        {(props.rowData.leftMemo) ?
                                            <TableRow>
                                                <TableCell>
                                                    <FormControl className={classes.formControl}>
                                                        <Chip size="small" style={{ color: 'black', backgroundColor: 'lightgray' }} label='Left Memo' />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell colSpan={6}>
                                                    <FormControl className={classes.formControl}>
                                                        <KarteMemo memo={props.rowData.leftMemo} />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            :
                                            <></>
                                        }
                                        {(props.rowData.leftOptionItemIds && props.rowData.leftOptionItemIds.length > 0) && <OptionText isLoading={props.isLoading} optionItemIds={props.rowData.leftOptionItemIds} leftRight={1} pd={props.rowData.leftPd} label='Left Option' />}
                                    </TableBody>
                                </Table>
                            </Form>
                        )}
                    </Formik>
                </TableCell>
            </TableRow >
        </>
    )

}) as React.FC<Props>
